import { Accordion } from '~/shared/components';
import React from 'react';
import { FooterNavigationNode } from '~/lib/data-contract';
import { MenuItem } from './components/MenuItem';
import { StyledMenuContainer } from './styled';

type MenuAreaProps = {
    menu?: FooterNavigationNode[];
};

export type MenuItemProps = {
    menuItem: FooterNavigationNode;
};

export const MenuArea = ({ menu }: MenuAreaProps) => (
    <Accordion>
        <StyledMenuContainer>
            {menu?.map((menuItem: MenuItemProps['menuItem']) => (
                <MenuItem key={menuItem.id} menuItem={menuItem} />
            ))}
        </StyledMenuContainer>
    </Accordion>
);
